import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { BanchedatiService } from '@services/banchedati.service';
import { ImageServiceService } from '@services/image-service.service';
import { MappingService } from '@services/mapping.service';
import { ModaleCreaService } from '@services/modale-crea.service';
import { Subscription } from 'rxjs';
import { LoaderComponent } from '../loader/loader.component';
import { MessageService } from '@services/message.service';

@Component({
  selector: 'app-modale-crea',
  templateUrl: './modale-crea.component.html',
  styleUrls: ['./modale-crea.component.scss'],
})
export class ModaleCreaComponent implements OnInit {
  form: FormGroup;
  public imageUrl: any;
  public faUpload = faUpload;
  public faTrashCan = faTrashCan;
  private subscription: Subscription = new Subscription();

  @Input() listaRegioni: any;
  @Input() nomiEnti: any;
  @Input() nomiProfili: any;
  @Input() combinedAnno: any;
  @Input() combinedEnti: any;
  @Input() combinedProfili: any;
  profileList: any[] = [];
  existPass: boolean = false;
  combinedLib: any;
  formError = false;
  librerie: any;
  updateCheck = false;
  tipologiaConcorso = 0;
  @Input() Anno: any;
  @Input() id: any;
  @Input() selectedFile: any;
  @Input() allEnti: any[] = [];
  @Input() useQuizAllCheck = false; //Modalità a parte per i quiz
  @Input() isQuizCheckAll = false; //Modalità a parte per i quiz
  @Input() filtersForQuiz: any = {};
  selectedRegioneName: string = '';

  constructor(
    private fb: FormBuilder,
    private banchedati: BanchedatiService,
    private mappingService: MappingService,
    private formService: ModaleCreaService,
    private imageService: ImageServiceService,
    private message: MessageService
  ) {
    this.form = this.fb.group({
      titolo: [, Validators.required],
      descrizione: [, Validators.required],
      ente: [, Validators.required],
      profilo: [, Validators.required],
      regione: [, Validators.required],
      anno: [, Validators.required],
      imageUrl: [, Validators.required],
    });
    this.form.get('imageUrl')?.valueChanges.subscribe((value) => {
      this.imageUrl = value;
    });
  }

  ngOnInit(): void {
    this.subscription.add(
      this.formService.getExistPass().subscribe((value) => {
        this.existPass = value;
      })
    );
    this.subscription.add(
      this.formService.getFormError().subscribe((value) => {
        this.formError = value;
      })
    );
    this.subscription.add(
      this.formService.getForm().subscribe((form) => {
        if (form) {
          this.form.patchValue(form);
        }
      })
    );
    // this.avvia();
    this.subscription.add(
      this.imageService.getCroppedImage().subscribe((image) => {
        if (image instanceof File) {
          let reader = new FileReader();
          reader.onload = (event: any) => {
            this.form.get('imageUrl')?.setValue(event.target.result);
          };
          reader.readAsDataURL(image);
        } else {
          this.imageUrl = '';
        }
      })
    );

    this.form.get('profilo')?.disable();

    // Subscribe to the value changes of the 'ente' field
    this.form.get('ente')?.valueChanges.subscribe((value) => {
      if (value) {
        // If 'ente' has a value, enable the 'profilo' field
        this.form.get('profilo')?.enable();
      } else {
        // If 'ente' does not have a value, disable the 'profilo' field
        this.form.get('profilo')?.disable();
      }
    });

    this.form.get('regione')?.valueChanges.subscribe(value => {
      this.updateRegioneName(value);
    });
  }

  showMessage(message: string, status: string) {
    this.message.showMessage(message, status);
  }

  changeType(type: number, event: any) {
    this.updateCheck = true;
    setTimeout(() => {
      this.tipologiaConcorso = event?.target?.value == 'true' ? type : 0;
      this.updateCheck = false;
    }, 0);
  }

  getProfiles(idEnte: string) {
    let myEnti = this.allEnti.find((ente: any) => ente.nome == idEnte)?.profili;
    if (myEnti) {
      myEnti = myEnti.filter((ente: any) => ente.nome != null).map((ente: any) => {
        return ente.nome;
      });
      this.profileList = myEnti
        ? JSON.parse(JSON.stringify(['', ...myEnti]))
        : [];
      this.form.get('profilo')?.setValue('');
    } else {
      this.profileList = [''];
    }
  }

  log(myCustomLog: any) {
    console.log(myCustomLog);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.imageService.setCroppedImage(null);

    this.formService.setError(false);
  }

  isFormEmpty() {
    for (let control in this.form.controls) {
      if (this.form.controls[control].value) {
        return false;
      }
    }
    return true;
  }

  exist() {
    const nome = this.form.get('titolo')?.value;
    const anno = this.form.get('anno')?.value;
    const descrizione = this.form.get('descrizione')?.value;
    if (nome && nome.trim() !== '') {
      return this.banchedati.exist(nome, descrizione, anno).subscribe(
        (response: any) => {
          this.formService.setExistPass(true);
          this.createBancaQuiz();
        },
        (error: any) => {
          console.error('Errore durante la creazione della materia:', error);
          this.showMessage(error.error.message, 'error');
        }
      );
    }
    return null;
  }

  onEnteChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const ente = target.value;
    if (this.combinedEnti.length > 0) {
      this.combinedEnti[0] = ente;
      this.combinedEnti = JSON.parse(JSON.stringify(this.combinedEnti));
    }
  }

  onProfiliChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const profilo = target.value;
    if (profilo) {
      this.profileList[0] = profilo;
      this.profileList = JSON.parse(JSON.stringify(this.profileList));
    }
  }

  submitForm() {
    this.formService.changeForm(this.form.value);
    this.exist();
  }

  show(event: Event) {
    event.preventDefault();
    this.imageService.setMostra(true);
    event.stopPropagation();
  }

  removeImage(event: Event) {
    event.preventDefault();
    this.form.get('imageUrl')?.setValue('');
    this.imageService.setCroppedImage(null);
  }

  onAnnoChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const anno = target.value;

    this.combinedAnno = [...this.Anno];

    this.combinedAnno.push(anno);
  }

  resetForm() {
    const emptyForm = {
      titolo: '',
      descrizione: '',
      ente: null,
      profilo: null,
      regione: null,
      anno: null,
      imageUrl: '',
    };

    this.formService.changeForm(emptyForm);
  }

  createBancaQuiz() {
    const titolo = this.form.get('titolo')?.value;
    const descrizione = this.form.get('descrizione')?.value;
    const ente = this.form.get('ente')?.value;
    const profilo = this.form.get('profilo')?.value;
    const regione = this.form.get('regione')?.value;
    const anno = this.form.get('anno')?.value;
    LoaderComponent.isLoading = true;

    const formData = new FormData();
    formData.append('tipologiaConcorso', this.tipologiaConcorso.toString());
    if (this.useQuizAllCheck) {
      // for (let id of this.id) {
      //   formData.append(
      //     this.isQuizCheckAll ? 'excludes[]' : 'includes[]',
      //     id.toString()
      //   );
      // }
      formData.append(
        this.isQuizCheckAll ? 'excludes[]' : 'includes[]',
        `[${this.id.toString()}]`
      );
      formData.append(!this.isQuizCheckAll ? 'excludes[]' : 'includes[]', '[]');

      this.filtersForQuiz.forEach((filter: any) => { delete filter.includes });
      formData.append('filters[]', JSON.stringify(this.filtersForQuiz));
      formData.append('idDomande[]', '[]');
    } else {
      for (let id of this.id) {
        formData.append('idDomande[]', id.toString());
      }
    }

    formData.append('nome', titolo);
    if (descrizione?.trim() !== '') {
      formData.append('descrizione', descrizione);
    }
    if (ente) {
      formData.append('ente', ente);
    }
    if (profilo) {
      formData.append('profilo', profilo);
    }
    if (regione) {
      formData.append('idRegione', regione);
    }
    if (anno) {
      formData.append('anno', anno);
    }
    if (this.selectedFile) {
      formData.append('cover', this.selectedFile);
    }

    console.log(formData);

    this.banchedati.createBancaDatiFromQuiz(formData).subscribe(
      (response: any) => {
        this.formService.setImport(false);
        this.showMessage(response.message, 'success');
        LoaderComponent.isLoading = false;
        this.mappingService.avvia().subscribe();
        this.formService.setConfirm(true);
        this.resetForm();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      },
      (error) => {
        console.error('Errore durante la creazione della banca dati:', error);
        if (error.status === 400) {
          this.showMessage('Compilare i campi correttamente', 'error');
          this.formService.setFormError(true);
        }

        LoaderComponent.isLoading = false;
      }
    );
    console.error(
      'Assicurati di compilare tutti i campi e selezionare un file.'
    );
  }

  private updateRegioneName(selectedId: any) {
    const item = this.listaRegioni.find((l: any) => l.id === selectedId);
    this.selectedRegioneName = item ? item.nome : '';
  }
}
